import React, { Component } from 'react';

class TimeSlot extends Component {
    render() {
        return (
            <tr className="TimeSlot">
                <td>
                    <input type="checkbox" />
                    <label>{this.props.timeSlot}
                    </label>
                </td>
            </tr>
        );
    }
}

export default TimeSlot;



// WEBPACK FOOTER //
// ./src/Componets/TimeSlot.js